import CustomAd from "@components/custom-ad/CustomAd";
import { useWindowSize } from "@components/window-size-provider";
import useMapCmsToScreenSize from "@hooks/useMapCmsToScreenSize";
import { showInfoModal } from "@lib/showModal";
import { getWordpressVars } from "@lib/wordpressVars";
import { usePostAdClickMutation } from "@mwServices/Ads";
import { Button } from "antd";
import { useEffect } from "react";

interface MonumetricAdsProps {
    slotId?: string;
    clientId?: string;
    imageUrl?: string;
    campaignUrl?: string;
    adId?: number;
    modalLink?: boolean;
    displayOn?: string[];
    sticky?: boolean;
}

const defaultProps: MonumetricAdsProps = {
    displayOn: []
};

const MonumetricAds = ({ slotId, clientId, imageUrl, campaignUrl, adId, modalLink = false, displayOn = [], sticky = false }: MonumetricAdsProps) => {
    const css: string[] = ["monumetric-ad", "ad-area"];
    const windowDimensions = useWindowSize();
    const showAd = useMapCmsToScreenSize(windowDimensions, displayOn);
    const ads = getWordpressVars().ads;
    const [postAdClick, postAdClickResponse] = usePostAdClickMutation();

    useEffect(() => {
        if (showAd && ads) {
            let interval = setInterval(() => {
                if (window.$MMT && slotId) {
                    window.$MMT.cmd = window.$MMT.cmd || [];
                    window.$MMT.cmd.push(function () {
                        window.$MMT.display.slots.push([slotId]);
                    });
                    clearInterval(interval)
                }
            }, 300)

            return () => {
                clearInterval(interval)
            }
        }
    }, [showAd, ads, slotId]);

    return (
        <>
            {(showAd && ads) &&
                (imageUrl && campaignUrl && adId) ?
                <CustomAd
                    campaignUrl={campaignUrl}
                    adId={adId}
                    imageUrl={imageUrl}
                    sticky={sticky}
                    displayOn={displayOn}
                />
                :
                <section className={css.join(' ')}>
                    {modalLink
                        && <Button
                            className={`why-ads-btn`}
                            type={`link`}
                            onClick={() => showInfoModal({
                                title: "Why Do We Show Ads?",
                                content: (
                                    <p>Although <strong>COVR</strong>PRICE charges a subscription for our collection management and price guide tools, our content section is free-to-all. As such, ads allow us to monetize this part of the website so that we can continue to produce high-quality content for you. Our goal is to provide ads that may be of interest to you, so please support <strong>COVR</strong>PRICE by clicking on some of our sponsors.<br />Thank you!</p>
                                ),
                                onOk() { },
                            })}
                        >Why Ads?
                        </Button>
                    }
                    <div id={slotId}></div>
                </section>
            }
        </>
    );
};

MonumetricAds.defaultProps = defaultProps;

export default MonumetricAds;
